import {
    AzLogicAppExpressionLanguage,
    TraceHandler,
    ErrorHandler,
    SymbolTable,
} from 'monaco-azure-logic-app-lang';

import { generateRootSymbolTableSync } from 'app/services/azure-logic-app-lang/common';
import { Activity, Dataset, LinkedService, Pipeline } from 'shell-models-lib';
import { ModelService } from 'app/model/services/model.service';

AzLogicAppExpressionLanguage.inLexicalDebugMode = false;
AzLogicAppExpressionLanguage.inSyntaxDebugMode = false;
AzLogicAppExpressionLanguage.inSemanticDebugMode = false;

// activate the AzLogicAppExpressionLanguage once loaded and it would trigger to seize the wasm asynchronously
AzLogicAppExpressionLanguage.activate();

export class AzLgcAppLangHelper {

    static get init(): Promise<unknown> {
        return AzLogicAppExpressionLanguage.init;
    }

    static set globalTraceHandler(traceHandler: TraceHandler | undefined){
        AzLogicAppExpressionLanguage.globalTraceHandler = traceHandler;
    }

    static set globalErrorHandler(errorHandler: ErrorHandler | undefined){
        AzLogicAppExpressionLanguage.globalErrorHandler = errorHandler;
    }

    static staticGenerateRootSymbolTableSync: (
        entity: Pipeline | Dataset | LinkedService | undefined,
        activity: Activity | undefined,
        _modelService: ModelService,
        hideEntityParameters?: boolean,
        showTriggerParameters?: boolean,
        showWorkspaceVariables?: boolean
    ) => SymbolTable = generateRootSymbolTableSync;

    public static staticManuallyParseSync(
        symbolTable: SymbolTable,
        text: string
    ){
        return AzLogicAppExpressionLanguage.manuallyParseSync(symbolTable, text);
    }


    private constructor() {
        // noop for now, reserved for latter
    }
}
